import { Link } from 'react-router-dom';
import { allGenres } from '@/utils/movies';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-600 text-background-50 mt-16">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-primary-600 text-xl w-5 h-5 flex items-center justify-center"></i>
              </span>
              <span className="font-heading font-extrabold text-lg tracking-tight">
                6080yy<span className="text-accent-400">电影</span>
              </span>
            </div>
            <p className="text-sm text-background-200/80 leading-relaxed max-w-md">
              6080yy电影在线看是一个面向广大影迷的高清电影内容平台，汇集最新热门影片与经典佳作，提供便捷的搜索、分类浏览与观影体验。本站播放演示为界面示范，不提供真实视频流。
            </p>
          </div>
          <div>
            <h4 className="font-label font-semibold text-sm mb-4 text-background-50">
              <span>快速导航</span>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  电影分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  搜索影片
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-label font-semibold text-sm mb-4 text-background-50">
              <span>热门分类</span>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {allGenres.slice(0, 5).map((genre) => (
                <li key={genre.key}>
                  <Link
                    to={`/category/${genre.key}`}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {genre.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-background-50/15 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © 2026 6080yy电影在线看 · 本站内容均为演示示范数据，仅供学习交流使用
          </p>
          <p className="text-xs text-background-200/70">联系我们：service@6080yy.example.com</p>
        </div>
      </div>
    </footer>
  );
}